/* eslint-disable jsx-a11y/label-has-associated-control */
import { useSelector } from 'react-redux';
import { Form } from 'semantic-ui-react';
import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DatePickerLayout from '../../../../../components/elements/DatePicker';
const Modal = ({
  t,
  recordID,
  title,
  setTitle,
  titleEn,
  setTitleEn,
  publicationDate,
  setPublicationDate,
  filmlocation,
  // handleOnSelectCountry,
  filmingLocation,
  keywords,
  setKeywords,
  showPreview,
  applyErrorClass,
  doc,
  setDoc,
  values,
  setLink,
  // content,
  // setContent,
  // contentEn,
  // setContentEn,
  onUpdate,
  onChange,
  setGridModalupdate,
  gridModalupdate,
  fileInputRef,
}) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const todayDate = new Date();

  return (
    <>
      {gridModalupdate ? (
        <>
          <MDBModal tabIndex="-1" show={gridModalupdate} setShow={setGridModalupdate}>
            <MDBModalDialog className="flex justify-center items-center">
              <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                  <MDBModalHeader>
                    <MDBModalTitle className="text-customgreen font-semibold">
                      {t('update')} {t('cms_photoGallery')}
                    </MDBModalTitle>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <div className="container-fluid bd-example-row">
                      <div className="row" style={{ marginBottom: '5px' }}>
                        <div className="col-md-6 col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('Title')} : </label>
                            <input
                              maxLength={1000}
                              type="text"
                              name="title"
                              value={title}
                              className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              required
                              onChange={(e) => setTitle(e.target.value)}
                              placeholder={t('Title')}
                            />
                          </Form.Field>
                        </div>
                        <div className="col-md-6 col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('Title En')} : </label>
                            <input
                              maxLength={1000}
                              type="text"
                              value={titleEn}
                              name="content"
                              className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              required
                              onChange={(e) => setTitleEn(e.target.value)}
                              placeholder={t('Title En')}
                            />
                          </Form.Field>
                        </div>

                        {/* <div className="col-md-6 col-example">
                          <label className="mx-auto text-customgreen">{t('cms_content')}: </label>
                          <textarea
                            type="text"
                            name="content"
                            value={content}
                            className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            onChange={(e) => setContent(e.target.value)}
                            placeholder={t('cms_content')}
                          />
                        </div> */}

                        {/* <div className="col-md-6 col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('Content En')} : </label>
                            <textarea
                              type="text"
                              name="content"
                              value={contentEn}
                              className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              required
                              onChange={(e) => setContentEn(e.target.value)}
                              placeholder={t('Content En')}
                            />
                          </Form.Field>
                        </div> */}
                      </div>
                      <div className="row" style={{ marginBottom: '5px' }}>
                        <div className="col-md-6 ms-auto col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('cms_filmingLocation')} : </label>
                            <input
                              type="text"
                              name="filmLocation"
                              disabled
                              value={isActive ? filmingLocation?.ar_SA : filmingLocation?.en_US}
                              className="cursor-not-allowed  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              // onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                              placeholder={t('cms_filmingLocation')}
                            />

                            {/* <select
                              name="filmLocation"
                              value={filmlocation}
                              required
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                              placeholder={t('cms_filmingLocation')}
                            >
                              <option value={0}>--{t('Select Country')}--</option>
                              {filmingLocation && filmingLocation.length > 0 ? (
                                filmingLocation?.map((item) => {
                                  return (
                                    <option key={item.countryID} value={item?.countryID}>
                                      {isActive ? item?.ar_SA : item?.countryName}
                                    </option>
                                  );
                                })
                              ) : (
                                <option>{t('Select country')}</option>
                              )}
                            </select> */}
                          </Form.Field>
                        </div>
                        <div className="col-md-6 ms-auto col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('cms_keywords')} : </label>
                            <input
                              type="text"
                              name="keywords"
                              value={keywords}
                              onChange={(e) => setKeywords(e.target.value)}
                              required
                              className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              placeholder={t('cms_keywords')}
                            />
                          </Form.Field>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 ms-auto col-example">
                          <Form.Field>
                            <div className="form-group flex flex-col gap-2 ">
                              <DatePickerLayout
                                label={'cms_publicationDate'}
                                selectedDate={publicationDate}
                                keyValue={'to'}
                                dateTo={publicationDate}
                                setDateTo={setPublicationDate}
                                maxDate={todayDate}
                              />
                            </div>
                          </Form.Field>
                        </div>
                        <div className="col-md-6 col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('cms_image')}</label>
                            <input
                              ref={fileInputRef}
                              onChange={(showPreview, onChange)}
                              type="file"
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            />
                          </Form.Field>
                        </div>
                        <div className="flex justify-center mt-2  ">
                          <img
                            style={{
                              height: '120px',
                              width: '150px',
                            }}
                            src={doc ? `data:image/jpeg;base64,${doc}` : values.imageSrc}
                            className="card-img-top"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </MDBModalBody>
                  <MDBModalFooter className="flex justify-center">
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
                      onClick={() => onUpdate(recordID)}
                    >
                      {t('Submit')}
                    </button>
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      onClick={() => setGridModalupdate(false)}
                    >
                      {t('close')}
                    </button>
                  </MDBModalFooter>
                </Form>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        </>
      ) : null}
    </>
  );
};

export default Modal;
